module.exports = __webpack_public_path__ + "img/ppob-ilustration-2.3c6b5c36.svg";